import { Component, Input, OnInit } from '@angular/core';
// Service
import { BroadcastService } from '@cv-invision/core';

@Component({
	selector: 'cv-custom-header',
	templateUrl: './custom-header.component.html',
	styleUrls: ['./custom-header.component.scss'],
})
export class CustomHeaderComponent implements OnInit {
	@Input() data: any;

	title: string;
	showBackButton = false
	backUrl = '';

	constructor(private broadcast: BroadcastService) {}

	ngOnInit(): void {
		if (this.data && this.data.title) {
			this.title = this.data.title;
		}

		if (this.data && this.data.backButton) {
			this.showBackButton = true;
			this.backUrl = this.data.backButton.url;
		}
	}

	/**
	 * return to the main intelligence module
	 */
	returnToMainModule(time: number): void {
		setTimeout(() => {
			this.broadcast.broadcast({
				name: 'GC_SUBHEADER_BACK',
				event: {}
			});
		}, time);
	}
}
